// extracted by mini-css-extract-plugin
module.exports = {"specialtySelect":"SearchBarSpecialtySelect_specialtySelect__3d5oY"};